<sc-scroll-pane *ngIf="registration != null && registration.transport != null">
    <sc-padding>
        <app-transport-details [layout]="layout" [transport]="registration.transport"
            [mode]="TransportDetailMode.EDITING" (validState)="onValidStateChanges($event)" (valueChange)="handleValueChange()"></app-transport-details>
        <app-service-response [responseMessages]="responseMessages"></app-service-response>
    </sc-padding>
</sc-scroll-pane>